import { Play } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { longFormProjects } from "@/data/portfolio";

const youtubeId = (url) =>
    url?.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/)?.[1];

const ProjectCard = ({ project, index }) => {
    const id = youtubeId(project.url);

    return (
        <Reveal delay={index * 0.06}>
            <div
                data-testid={`longform-card-${project.id}`}
                className="group relative aspect-video w-full overflow-hidden rounded-3xl border border-white/10 bg-ink-3 shadow-[0_24px_70px_-30px_rgba(0,0,0,0.9)] transition-[border-color,box-shadow] duration-500 hover:border-flame/40 hover:shadow-[0_30px_90px_-30px_rgba(255,75,38,0.25)]"
            >
                {id ? (
                    <iframe
                        data-testid={`longform-embed-${project.id}`}
                        src={`https://www.youtube.com/embed/${id}`}
                        title={project.title}
                        loading="lazy"
                        className="h-full w-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                ) : (
                    <>
                        <img
                            src={project.thumbnail}
                            alt={project.title}
                            loading="lazy"
                            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.045]"
                        />
                        <div
                            className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/10 to-transparent"
                            aria-hidden="true"
                        />
                        <span
                            className="absolute left-1/2 top-1/2 grid h-16 w-16 -translate-x-1/2 -translate-y-1/2 scale-75 place-items-center rounded-full bg-flame text-white opacity-0 shadow-[0_0_50px_rgba(255,75,38,0.5)] transition-[opacity,transform] duration-500 group-hover:scale-100 group-hover:opacity-100"
                            aria-hidden="true"
                        >
                            <Play size={22} fill="currentColor" className="ml-0.5" />
                        </span>
                    </>
                )}
            </div>
        </Reveal>
    );
};

const LongFormProjects = () => {
    const [first, second, third] = longFormProjects;

    return (
        <section id="work" data-testid="longform-section" className="relative py-12 sm:py-16">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    index={2}
                    eyebrow="Portfolio"
                    title={
                        <>
                            Long Form{" "}
                            <em className="font-serifit text-[1.06em] font-medium italic text-[#f6e3d3]">
                                Videos
                            </em>
                        </>
                    }
                    subtitle="Long-form edits designed to keep viewers engaged from beginning to end."
                />
                <div className="grid gap-6 sm:gap-8 md:grid-cols-2">
                    <ProjectCard project={first} index={0} />
                    <ProjectCard project={second} index={1} />
                </div>
                {third && (
                    <div className="mx-auto mt-6 w-full sm:mt-8 md:max-w-[calc(50%-1rem)]">
                        <ProjectCard project={third} index={2} />
                    </div>
                )}
            </div>
        </section>
    );
};

export default LongFormProjects;
